document.addEventListener('DOMContentLoaded', function() {
  
  // Função para abrir o minicart
  function openMinicart() {
    const minicart = document.querySelector('.minicart');
    minicart.classList.add('open');
    document.documentElement.style.overflow = 'hidden';
  }

  // Função para fechar o minicart
  function closeMinicart() {
    const minicart = document.querySelector('.minicart');
    minicart.classList.remove('open');
    document.documentElement.style.overflow = 'scroll';
  }

  // Função para buscar o carrinho e atualizar o minicart
  function fetchAndUpdateMinicart() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        updateMinicartUI(cart);
      })
      .catch(error => {
        console.error('Error fetching cart:', error);
      });
  }

  // Função para atualizar o UI do minicart
  function updateMinicartUI(cart) {
    const minicartItemsContainer = document.querySelector('.minicart-items');
    const minicart = document.querySelector('.minicart');
    minicartItemsContainer.innerHTML = '';

    if (cart.items.length === 0) {
      minicart.classList.add('empty');
      minicartItemsContainer.innerHTML = `
        <p>Sua sacola está vazia <br> <strong>Adicione itens em sua sacola</strong></p>
      `;
      return;
    } else {
      minicart.classList.remove('empty');
    }

    cart.items.forEach(item => {
      let optionsHtml = '';  // Inicializa a variável para armazenar o HTML
      if (item.options_with_values && item.options_with_values.length > 0) {
        item.options_with_values.forEach(option => {
          optionsHtml += `
            <div class="product-option">
              <dt>${option.name}:</dt>
              <dd>${option.value}</dd>
            </div>
          `;
        });
      }
      const itemHtml = `
        <div class="cart-item" data-id="${item.id}">
          <a href="${item.url}"><img src="${item.image}" alt="${item.product_title}" width="64" height="96"></a>
          <div class="cart-item-details">
            <div class="item-name">
              <a href="${item.url}">${item.product_title}</a>
              <button class="remove-item" data-id="${item.id}"></button>
            </div>
            
            ${optionsHtml}
             <div class="item-bottom">
              <div class="quantity-control">
                <button class="quantity-decrease" data-id="${item.id}">-</button>
                <input type="text" class="quantity-input" value="${item.quantity}" data-id="${item.id}">
                <button class="quantity-increase" data-id="${item.id}">+</button>
              </div>
              <p class="item-price" data-id="${item.id}">${(item.line_price / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</p>
           
            </div>
          </div>
        </div>
      `;
      minicartItemsContainer.innerHTML += itemHtml;
    });

    // Atualiza o total do minicart
    document.querySelector('.minicart-total-price').textContent = (cart.total_price / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  // Função para manipular a quantidade de itens
  function updateCartQuantity(id, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: id,
        quantity: quantity
      })
    })
    .then(response => response.json())
    .then(cart => {
      fetchAndUpdateMinicart();
    })
    .catch(error => {
      console.error('Error updating cart:', error);
    });
  }

  // Listeners para adicionar/remover quantidade e remover itens
  document.addEventListener('click', function(event) {
    if (event.target.classList.contains('remove-item')) {
      const id = event.target.getAttribute('data-id');
      
      // Remove o item imediatamente da interface
      const cartItem = document.querySelector(`.cart-item[data-id="${id}"]`);
      if (cartItem) {
        cartItem.remove();  // Remove o item do DOM
      }

      // Atualiza o carrinho e o minicart após remoção
      updateCartQuantity(id, 0);
    }

    if (event.target.classList.contains('quantity-increase')) {
      const id = event.target.getAttribute('data-id');
      updateCartQuantity(id, parseInt(document.querySelector(`input[data-id="${id}"]`).value) + 1);
    }

    if (event.target.classList.contains('quantity-decrease')) {
      const id = event.target.getAttribute('data-id');
      const currentQuantity = parseInt(document.querySelector(`input[data-id="${id}"]`).value);
      if (currentQuantity > 1) {
        updateCartQuantity(id, currentQuantity - 1);
      }
    }
  });

  // Listener para abrir o minicart após adicionar produto
  document.addEventListener('product:added', function() {
    fetchAndUpdateMinicart(); // Atualiza o minicart
    openMinicart(); // Abre o minicart
  });

  // Listener para fechar o minicart
  document.querySelector('#close-minicart').addEventListener('click', closeMinicart);
  document.querySelector('#minicart-bg').addEventListener('click', closeMinicart);

    
  function calcularFrete() {
      var cep = document.getElementById('cep').value.replace(/\D/g, ''); // Remove qualquer caractere não numérico
      if (cep.length === 8) {
          // Adiciona o carregando enquanto faz a requisição
          document.getElementById('resultado-frete').innerHTML = '<span class="loading">Calculando frete...</span>';
  
          // Faz a consulta para obter o estado (province) a partir do CEP
          fetch(`https://viacep.com.br/ws/${cep}/json/`)
              .then(response => response.json())
              .then(data => {
                  if (data.uf) {
                      var estado = data.uf; // Recupera o estado (província)
                      var pais = 'BR'; // País fixo como Brasil
  
                      // Faz a requisição para calcular o frete com o estado recuperado
                      fetch(`/cart/shipping_rates.json?shipping_address[zip]=${cep}&shipping_address[country]=${pais}&shipping_address[province]=${estado}`)
                          .then(response => response.json())
                          .then(data => {
                              if (data.shipping_rates && data.shipping_rates.length > 0) {
                                  var resultado = '<ul>';
                                  resultado += `<li class="title-result"><span>Nome</span> <span>Prazo</span> <span>Valor</span></li>`;
                                  data.shipping_rates.forEach(rate => {
                                      // Usa diretamente o campo data.description para o prazo de entrega
                                      var prazoEntrega = rate.description ? rate.description : '';
                                      // Formata o preço para o formato de moeda BRL
                                      var precoFormatado = Number(rate.price).toLocaleString('pt-BR', {
                                          style: 'currency',
                                          currency: 'BRL'
                                      });

                                      if(rate.price == 0){
                                        precoFormatado = "Grátis";
                                      }
  
                                      // Exibe o nome, preço e prazo de entrega (se disponível)
                                      resultado += `<li><span class="shipping-name">${rate.name}</span>  <span class="shipping-estimate"> ${prazoEntrega}</span> <span class="shipping-price">${precoFormatado}</span></li>`;
                                  });
                                  resultado += '</ul>';
                                  document.getElementById('resultado-frete').innerHTML = resultado;
                              } else {
                                  document.getElementById('resultado-frete').innerHTML = '<span class="not-possible">Não foi possível calcular o frete.</span>';
                              }
                          })
                          .catch(error => {
                              document.getElementById('resultado-frete').innerHTML = '<span class="error-cep">Erro ao calcular o frete.</span>';
                          });
                  } else {
                      document.getElementById('resultado-frete').innerHTML = '<span class="error-cep">CEP não encontrado ou inválido.</span>';
                  }
              })
              .catch(error => {
                  document.getElementById('resultado-frete').innerHTML = '<span class="error-cep">Erro ao buscar o estado do CEP.</span>';
              });
      } else {
          document.getElementById('resultado-frete').innerHTML = '<span class="cep-invalid">Por favor, insira um CEP válido.</span>';
      }
  }
  
  // Aciona o cálculo do frete ao clicar no botão
  document.getElementById('calcular-frete').addEventListener('click', calcularFrete);
  
  // Aciona o cálculo do frete ao pressionar a tecla "Enter"
  document.getElementById('cep').addEventListener('keypress', function(event) {
      if (event.key === 'Enter') {
          calcularFrete();
      }
  });
  
  if (document.querySelector('.shipping-simulator .shipping-calculator__header')) {
      // Adiciona o evento de clique abrir e fechar calculo de frete
      document.querySelector('.shipping-simulator .shipping-calculator__header').addEventListener('click', function() {
          var shippingSimulator = document.querySelector('.shipping-simulator');
          shippingSimulator.classList.toggle('show');
      });
  }

});




